import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "i-1787014943__Layer_1",
  x: "0",
  y: "0",
  style: {"enable-background":"new 0 0 100 100"},
  version: "1.1",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".i-1787014943__st1{fill:currentColor}")
      ])),
      _: 1,
      __: [0]
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M96.8 5.1v31.1c0 3.7-1.4 7.3-4 10L48.3 92.4c-5.4 5.6-14.4 5.7-20 .2L8.4 73c-5.7-5.6-5.7-14.9.1-20.4l46-45.4c2.3-2.2 5.3-3.6 8.4-3.9h31.9c1.1-.1 2 .7 2 1.8z",
      style: {"fill":"none","stroke":"currentColor","stroke-width":"2.8346"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "90.3",
      cy: "9.5",
      r: "1.9",
      class: "i-1787014943__st1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M31.9 60.2 28.1 64c-1.6-1-3.4-.7-5.3 1.3-.8.7-1.4 1.7-1.6 2.6-.2.9 0 1.7.7 2.3.9.9 2.3.8 4-.5l3.9-2.8c3.9-2.6 7.2-2.5 10.1.3 1.6 1.6 2.3 3.6 2.2 5.9s-1.4 4.6-3.8 7c-2.3 2.3-4.6 3.6-6.9 3.8-2.4.3-4.6-.3-6.5-2l3.8-3.8c2.1 1.5 4.2.9 6.5-1.4 1-1 1.6-2 1.8-3s-.1-1.8-.8-2.5c-.5-.6-1.3-.8-2-.8-.7.1-1.6.5-2.5 1.1l-4 2.9c-3.6 2.5-6.8 2.4-9.5-.3-1.5-1.5-2.2-3.4-2.1-5.6.2-2.2 1.4-4.4 3.4-6.4s4-3.1 6.2-3.4c2.4-.5 4.3.1 6.2 1.5zM59.3 58.8 53 55.4l-6.9 6.9 3.4 6.3-3.7 3.7-12.2-23.7 5.9-5.9 23.6 12.2-3.8 3.9zM39.6 50l4.4 8.1 4.8-4.8-8.1-4.4-1.1 1.1zM64.7 46.5l9.5-9.5 3.4 3.4-13.2 13.4-18-17.9 3.8-3.8 14.5 14.4zM79.8 31.6l9.8-9.8 3.3 3.3-13.4 13.5-17.9-17.9L74.8 7.4l3.3 3.3-9.5 9.5 3.8 3.8 7.5-7.5 3.2 3.2-7.5 7.5 4.2 4.4z",
      class: "i-1787014943__st1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "sale"}) } }